import React from "react";
import { Routes, Route } from "react-router-dom";

import TopInfoBar from "./components/TopInfoBar";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Courses from "./components/Courses";
import Internship from "./components/Internship";
import Features from "./components/Features";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import AboutUs from "./Pages/AboutUs";
import AllCourses from "./Pages/AllCourses";
import ContactUs from "./Pages/ContactUs";
import Blog from "./components/Blog";
import Blogs from "./Pages/Blogs";
import Blog1 from "./Pages/Blog1";
import Blog2 from "./Pages/Blog2";
import Mern from "./Pages/Mern";
import Analytics from "./Pages/Analytics";
import Django from "./Pages/Django";
import FullStack from "./Pages/Fullstack";
import Marketing from "./Pages/Marketing";
import Reactt from "./Pages/Reactt";
import Placements from "./components/Placements";
import DevOps from "./Pages/DevOps";
import CyberSecurity from "./Pages/CyberSecurity";

import ScrollToTop from "./components/ScrollToTop";


function App() {
  return (
    <>
   
    <TopInfoBar/>
    <Navbar />
    <ScrollToTop />
    <Routes>
    
      <Route
        path="/"
        element={
          <>
            
            <Hero />
            <Placements/>
            <Courses />
            <Internship />
            <Features />
            <Testimonials />
            <Blog/> 
            
          </>
        }
      />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/allcourses" element={<AllCourses />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/blog-post" element={<Blog1 />} />
      <Route path="/blog-post2" element={<Blog2 />} />
      <Route path="/course-mern" element={<Mern />} />
      <Route path="/course-data" element={<Analytics />} />
      <Route path="/course-python" element={<Django />} />
      <Route path="/course-fullstack" element={<FullStack />} />
      <Route path="/course-marketing" element={<Marketing />} />
      <Route path="/course-react" element={<Reactt />} />
      <Route path="/course-devops" element={<DevOps />} />
      <Route path="/course-cybersecurity" element={<CyberSecurity />} />



     
    </Routes>
    <Footer />
    </>
  );
}

export default App;
